import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import home from './modules/home'
import login from './modules/login'
import supply from './modules/supply'
import orderList from './modules/orderList'
import chat from './modules/chat'
import childrenAccount from './modules/childrenAccount'
import videoAccount from './modules/videoAccount'
Vue.use(Vuex)

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    home,
    login,
    supply,
    orderList,
    chat,
    childrenAccount,
    videoAccount
  }
})
